import React from "react"
import { useCurrentUser } from "~/auth/CurrentUserContext"
import { MarketplaceUpgradeCard } from "./MarketplaceUpgradeCard"

// Wraps a page that requires the Marketplace plan (ZAN-854). The server
// refuses the page's data to anyone without access (ZAN-921), so when locked
// the page itself is never mounted: a static sample teaser is blurred behind
// the upgrade card instead. Screens skip their own queries while locked.
export const MarketplaceGate = ({
  teaser,
  children,
}: {
  teaser: React.ReactNode
  children: React.ReactNode
}) => {
  const user = useCurrentUser()

  if (user.canAccessMarketplacePages.value) {
    return <>{children}</>
  }

  return (
    <div className="relative h-full select-none">
      <div className="h-full blur-sm pointer-events-none" aria-hidden="true">
        {teaser}
      </div>
      <MarketplaceUpgradeCard />
    </div>
  )
}
